import React, { useRef, useEffect } from 'react'
import QRCode from 'qrcode'

const AssetQRCode = ({value, size = 128}) => {
  const canvasRef = useRef(null)
  
  useEffect(() => {
    QRCode.toCanvas(
      canvasRef.current,
      value,
      {
        width: size,
        margin: 0,
      },
      (error) => {
        if (error) console.error(error)
      }
    )
  }, [value, size])

  return (
    <canvas ref={canvasRef} />
  )
}

export default AssetQRCode
